import { useEffect, useState } from 'react';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { MARKETS_ALL, TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';

const LIST_EXPRESS = [
  { name: 'Нет', value: false },
  { name: 'Да', value: true },
];
const CreateRealizationPopUp = ({ close = () => { } }) => {
  const [data, setData] = useState({
    time_scheduled: null,
    info: '',
    market: '',
  });
  const [market, setMarket] = useState(Object.keys(MARKETS_ALL)[0]);
  const [shop, setShop] = useState();
  const [isExpress, setIsExpress] = useState({ name: 'Нет', value: false });

  const validate = () => {
    return data.time_scheduled;
  };

  const clickAdd = () => {
    if (validate()) {
      /*createShipment(market.toLowerCase(), MARKETS_MAP[shop], data.time_scheduled, isExpress.value).then((r) => {
        close();
      });*/
    }
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS_ALL)[0]);
  }, []);

  useEffect(() => {
    if (market) {
      setShop(MARKETS_ALL[market][0]);
    }
    if (market === 'Sber' || market === 'Wb') {
      setIsExpress(LIST_EXPRESS[0]);
    }
  }, [market]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить новую реализацию</H2>
      <Row>
        <div style={{ marginRight: '25px' }}>
          <Select
            list={Object.keys(MARKETS_ALL)}
            select={market}
            label="Площадка"
            onSelect={(v) => setMarket(v)}
            width={'150px'}
          />
        </div>
        <div>
          <Select
            list={LIST_EXPRESS}
            select={isExpress}
            label="Экспресс"
            valueFn={(v) => v.name}
            disabled={market === 'Sber' || market === 'Wb'}
            onSelect={(v) => setIsExpress(v)}
            width={'200px'}
          />
        </div>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <InputLabel style={{ marginRight: '20px' }}>Дата реализации</InputLabel>
        <DateInput onChange={(v) => setData({ ...data, time_scheduled: v })} />
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={!data.time_scheduled}
          style={{
            marginRight: '15px',
          }}
          onClick={!data.time_scheduled ? () => { } : clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateRealizationPopUp;
